import { type IExpenseRepository } from '@webapp/modules/expense/business-logic/interfaces/IExpenseRepository'

export class CheckHasWatchlistApproversUseCase {
  constructor(
    private readonly deps: {
      expenseRepository: IExpenseRepository
    }
  ) {}

  execute = async (): Promise<boolean> => {
    const result = await this.deps.expenseRepository.listWatchlistApprovers({
      page: 1,
      pageSize: 1,
    })

    return result.data.length > 0
  }
}
